import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './layout';
import Home from './pages/home';
import Profiles from './pages/profiles';
import MovieDetails from './pages/movie-details';
import AuthPage from './pages/auth';
import SearchMovieType from './pages/search-movies-type'
import SearchAllMovies from './pages/search-all-movies';
import Settings from './pages/settings';
import Channels from './pages/channels';

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/login" element={<Layout><AuthPage /></Layout>} />
        <Route path="/profiles" element={<Layout noHeaderFooterPaths={['/profiles']}><Profiles /></Layout>} />
        <Route path="/configuracoes/:page" element={<Layout><Settings /></Layout>} />
        <Route path="/details/:movieType/:movieId/:movieIdImdb" element={<Layout><MovieDetails /></Layout>} />
        <Route path="/pesquisar" element={<Layout><SearchAllMovies /></Layout>} />
        <Route path="/pesquisar/:mediaType/" element={<Layout><SearchMovieType /></Layout>} />
        <Route path="/pesquisar/genero/:mediaType/:generoId" element={<Layout><MovieDetails /></Layout>} />
        <Route path="/canais" element={<Layout><Channels /></Layout>} />
      </Routes>
    </Router>
  );
  
}

export default App;
